
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Account } from '@/modules/admin/me';
import { UserTypes } from '@/enums/userTypes';
import { FunctionTypes } from '@/enums/functionTypes';

export default class AvaivaledVue extends Vue {

  protected UserTypes = UserTypes;
  protected FunctionTypes = FunctionTypes;

  protected get user(): Account {
    return this.$store.state.me.user;
  }

  protected get userRole(): UserTypes {
    return this.$store.getters['auth/userType'];
  }

  get availableFunction(): number {
    if (!this.user) {
      return 0;
    }
    return this.user.availableFunctionbit;
  }

  protected async pageBackCheck( type: FunctionTypes ) {
    if (!this.user) {
      await this.$store.dispatch('me/fetchMyData');
    }

    if ((this.availableFunction & type) !== type) {
      // URL直打ち遷移対策としてTOPに戻す
      this.$router.push({ name: 'Top' });
      return false;
    }

    return true;
  }
}
